import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { 
    Grid,
    makeStyles,
} from '@material-ui/core'
import { useForm } from "../../hooks/useForm";
import { getArchivosContrataciones, getParametrosContrataciones, setArchivosContrataciones } from '../../actions/archivosContrataciones';
import TableSubidaArchivosContrataciones from './TableSubidaArchivosContrataciones';
import { PlantillaContrataciones } from './PlantillaContrataciones';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(2)
    },
    rootDatos: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        padding: 10,
        marginTop: 20
    },
    button: {
        marginTop: theme.spacing(2),
        float: "right"
    },
    input: {
        display: 'none',
    },
}));

const stateInitial = {
    selectedDateDesde: null,
    selectedDateHasta: null,
    selectedTipoArchivo: "0"
};

const ArchivosContratacionesScreen = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { archivosContrataciones } = useSelector(state => state.archivosContrataciones)

    const [formValues, , , setearValor] = useForm(stateInitial);
    const { selectedDateDesde, selectedDateHasta, selectedTipoArchivo } = formValues;

    const handleSearch = (e) => {
        dispatch(getArchivosContrataciones(selectedTipoArchivo, selectedDateDesde, selectedDateHasta))
    };

    useEffect(() => () => dispatch(setArchivosContrataciones([])), []);
    
    useEffect(() => {
        dispatch(getParametrosContrataciones())
    }, []);

    return (
        <div className={classes.root}>
            <Grid container spacing={1} direction="row" justify="center" alignItems="center">
                <Grid item xs={12} md={10} style={{display: 'flex', justifyContent: 'space-between'}}>
                    <PlantillaContrataciones descarga />
                    <PlantillaContrataciones 
                        selectedDateDesde={selectedDateDesde} 
                        selectedDateHasta={selectedDateHasta} 
                        selectedTipoArchivo={selectedTipoArchivo} 
                    />
                </Grid>
                <Grid item xs={12} md={10}>
                    <TableSubidaArchivosContrataciones
                        data={archivosContrataciones ?? []}
                        setearValor={setearValor}
                        selectedDateDesde={selectedDateDesde}
                        selectedDateHasta={selectedDateHasta}
                        selectedTipoArchivo={selectedTipoArchivo}
                        handleSearch={handleSearch}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

export default ArchivosContratacionesScreen
